import React from 'react';
import { ListItem, UnorderedList, OrderedList } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
var LIST_COMPONENTS = {
  bullets: UnorderedList,
  numbers: OrderedList
};

var ListAdapter = function ListAdapter(_ref) {
  var _ref$list_type = _ref.list_type,
      list_type = _ref$list_type === void 0 ? 'bullets' : _ref$list_type,
      list = _ref.list;
  var ListContainer = LIST_COMPONENTS[list_type];
  return /*#__PURE__*/_jsx(ListContainer, {
    $variant: "default",
    children: list.map(function (item, index) {
      return /*#__PURE__*/_jsx(ListItem, {
        children: item.html
      }, index);
    })
  });
};

export default ListAdapter;